import Axios from '@/api/http'

/**
 * 清除记取
 * */
export function apiClearcaShdata (query) {
  return Axios({
    method: 'post',
    url: '/api/clearcashdata',
    data: query
  })
}

/**
 * 获取省市三级
 * */
export function getregiondictlist (query) {
  return Axios({
    method: 'post',
    url: '/openapi/getregiondictlist',
    data: query
  })
}


